import { setShouldShowFRECallouts } from 'owa-group-files-hub-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { LightningProps, lightable } from 'owa-lightning-v2';
import { observer } from 'mobx-react';
import * as React from 'react';

@observer
@lightable
export class FilesHubFRE extends React.Component<LightningProps, {}> {
    render() {
        if (isFeatureEnabled('grp-groupFileshubFRE')) {
            setShouldShowFRECallouts(true);
        }

        return null;
    }
}
